// extracted by mini-css-extract-plugin
export default {"MainCont":"Mixing_MainCont__iFsei","LeftCont":"Mixing_LeftCont__ary6L","RightCont":"Mixing_RightCont__HFTlU"};